// ===============================
// EcommerceHeader.jsx
// ===============================

import React, { useState } from "react";
import "./Header.css";
import {
  useContext,
} from "react";

import {
  CartContext,
} from "../../context/CartContext";
import { Link, NavLink } from "react-router-dom";

const EcommerceHeader = () => {
  const [menuOpen, setMenuOpen] = useState(false);
const {
  totalItems,
} = useContext(CartContext);
  return (
    <>
      {/* TOP BAR */}
      <div className="top-bar">
        <div className="container top-bar-content">
          <p>
            <i className="fa-solid fa-truck"></i>
            Free Shipping on Orders Above ₹999
          </p>

          <div className="top-links">

            <Link to="/">
              Track Order
            </Link>

            <Link to="/contact">
              Support
            </Link>

          </div>
        </div>
      </div>

      {/* HEADER */}
      <header className="eco-header">

        <div className="container nav-wrapper">

          {/* LOGO */}
          <div className="logo">
            <Link to="/">
              <span>Sab</span> Milega
            </Link>
          </div>

          {/* SEARCH */}
          <div className="search-box">

            <input
              type="text"
              placeholder="Search products..."
            />

            <button>
              <i className="fa-solid fa-magnifying-glass"></i>
            </button>

          </div>

          {/* ICONS */}
          <div className="nav-icons">

            <Link to="/profile">
              <i className="fa-regular fa-user"></i>
            </Link>

            <Link to="/wishlist">
              <i className="fa-regular fa-heart"></i>
            </Link>

            <Link to="/cart" className="cart-icon">
              <i className="fa-solid fa-bag-shopping"></i>
              <span>{totalItems}</span>
            </Link>

            {/* MOBILE MENU BUTTON */}
            <button
              className="menu-btn"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <i className="fa-solid fa-bars"></i>
            </button>

          </div>
        </div>

        {/* MENU */}
        <nav className={`menu ${menuOpen ? "active" : ""}`}>
          <div className="container menu-links">

            <NavLink
              to="/"
              className={({ isActive }) =>
                isActive ? "active" : ""
              }
              onClick={() => setMenuOpen(false)}
            >
              Home
            </NavLink>

            <NavLink
              to="/shop"
              className={({ isActive }) =>
                isActive ? "active" : ""
              }
              onClick={() => setMenuOpen(false)}
            >
              Shop
            </NavLink>

            <NavLink
              to="/new-arrivals"
              className={({ isActive }) =>
                isActive ? "active" : ""
              }
              onClick={() => setMenuOpen(false)}
            >
              New Arrivals
            </NavLink>

            <NavLink
              to="/trending"
              className={({ isActive }) =>
                isActive ? "active" : ""
              }
              onClick={() => setMenuOpen(false)}
            >
              Trending
            </NavLink>

            <NavLink
              to="/categories"
              className={({ isActive }) =>
                isActive ? "active" : ""
              }
              onClick={() => setMenuOpen(false)}
            >
              Categories
            </NavLink>

            <NavLink
              to="/deals"
              className={({ isActive }) =>
                isActive ? "active" : ""
              }
              onClick={() => setMenuOpen(false)}
            >
              Deals
            </NavLink>

            <NavLink
              to="/contact"
              className={({ isActive }) =>
                isActive ? "active" : ""
              }
              onClick={() => setMenuOpen(false)}
            >
              Contact
            </NavLink>

          </div>
        </nav>

      </header>
    </>
  );
};

export default EcommerceHeader;